export default __webpack_public_path__ + "static/media/fatura.b443e107.jpeg";